import styled from "styled-components";
import { colors } from "./../DateList/elements";

export const TimelineWrapper = styled.div`
  --others: calc(
    calc(calc(var(--sidebarWidth) + var(--outerMargin)) + var(--outerMargin)) +
      var(--gap)
  );
  max-width: calc(100vw - var(--others));
  overflow-x: scroll;
`;

export const TimelineDiv = styled.div`
  --width: ${(props) => (props.width ? props.width : 2000)};
  --height: ${(props) => (props.height ? props.height : 500)};
  --tenthHeight: calc(
    var(--height) / ${(props) => (props.channels ? props.channels : 10)}
  );
  width: var(--width);
  min-width: calc(1px * var(--width));
  position: relative;
  background-color: var(--white);
  color: var(--black);
  box-sizing: border-box;
  padding: var(--gap);
  height: calc(1px * var(--height));
`;

export const YearsDiv = styled.div`
  --width: ${(props) => (props.width ? props.width : 2000)};
  width: var(--width);
  min-width: calc(1px * var(--width));
  position: relative;
  background-color: var(--white);
  color: var(--black);
  box-sizing: border-box;
  padding: var(--gap);
  height: 50px;
  border-bottom: 1px solid var(--background);
`;

export const YearMarker = styled.div`
  position: absolute;
  top: 0;
  height: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid var(--black);
  padding-left: var(--gap);
  left: ${(props) =>
    props.left ? "calc(var(--width) * " + props.left + "px)" : "10px"};
`;

export const TimelineObject = styled.div`
  --accentColor: ${(props) =>
    props.objectType
      ? colors[props.objectType] || "var(--linkColor)"
      : "var(--linkColor)"};
  position: absolute;
  width: ${(props) => {
    return props.objectWidth
      ? "calc(var(--width) * " + props.objectWwidth + "px)"
      : "10px";
  }};
  border-top-color: var(--accentColor);
  border-top-width: 4px;
  border-top-style: ${(props) =>
    props.objectWidth > 0.1 ? "dashed" : "solid"};
  min-width: 150px;
  /* border-radius: var(--gap);
  border-top-left-radius: 0;
  border-top-right-radius: ${(props) =>
    props.width > 0.1 ? 0 : "var(--gap)"}; */
  background-color: var(--white);
  color: var(--black);
  box-shadow: 0 0 20px var(--white);
  box-sizing: border-box;
  top: ${(props) =>
    props.top ? "calc(var(--tenthHeight) * " + props.top + "px)" : "10px"};
  left: ${(props) =>
    props.left ? "calc(var(--width) * " + props.left + "px)" : "10px"};
  & a {
    color: var(--accentColor);
    width: 100%;
    height: 100%;
    display: inline-block;
    padding-top: 4px;
  }
  &:before {
    position: absolute;
    content: "";
    left: 0;
    top: -15px;
    height: 15px;
    border-left-color: var(--accentColor);
    border-left-width: 4px;
    border-left-style: ${(props) => (props.width > 0.1 ? "dashed" : "solid")};
  }
  &:hover {
    z-index: 999;
    box-shadow: 0 0 50px var(--white);
  }
`;
